export enum OrderType {
    EAT_IN = "Eat in",
    TAKEAWAY = "Takeaway"
}